import { useSelector } from "react-redux";
import {
  addLayer,
  fetch,
  fetchLayersRequest,
  fetchSourceResponseFormatter,
  layerResponseFormatter,
  trans,
} from "../../lib/utils";
import store from "../../stores/store";

function addDiagToMap(value) {
  var _layertitle = value.replace("map_ras_lso", "mapraslso");

  _layertitle = _layertitle.replace("map_ras_vlso", "maprasvlso");

  _layertitle = _layertitle.replace("map_ras_gys5k", "maprasgus5k");

  var _splitName = _layertitle.split("_");

  var _splitNameSpace = _splitName[0];

  var _serviceUrl = "";

  switch (_splitNameSpace) {
    case "maprasgus5k":
      _serviceUrl = "https://services.heraklion.gr/geoserver/herakliogys/wms";
      break;

    case "mapraslso":
      _serviceUrl = "https://services.heraklion.gr/geoserver/herakliolso/wms";
      break;

    case "maprasvlso":
      _serviceUrl = "https://services.heraklion.gr/geoserver/herakliovlso/wms";
      break;

    case "gps":
      _serviceUrl = "https://services.heraklion.gr/geoserver/herakliogps/wms";
      break;

    case "agp":
      _serviceUrl = "https://services.heraklion.gr/geoserver/heraklioagp/wms";
      break;

    case "map":
      _serviceUrl = "https://services.heraklion.gr/geoserver/herakliow/wms";
      break;

    case "oik":
      _serviceUrl = "https://services.heraklion.gr/geoserver/herakliooik/wms";
      break;

    case "pef":
      _serviceUrl = "https://services.heraklion.gr/geoserver/herakliopef/wms";
      break;

    case "rym":
      _serviceUrl = "https://services.heraklion.gr/geoserver/herakliorym/wms";
      break;

    case "trs":
      _serviceUrl = "https://services.heraklion.gr/geoserver/herakliotrs/wms";
      break;

    case "rem":
      _serviceUrl = "https://services.heraklion.gr/geoserver/herakliorem/wms";
      break;

    case "dnm":
      _serviceUrl = "https://services.heraklion.gr/geoserver/herakliodnm/wms";
      break;

    case "tsp":
      _serviceUrl = "https://services.heraklion.gr/geoserver/herakliotsp/wms";
      break;

    case "mik":
      _serviceUrl = "https://services.heraklion.gr/geoserver/herakliomik/wms";
      break;

    default:
      _serviceUrl = "https://services.heraklion.gr/geoserver/herakliotsp/wms";
      break;
  }

  if (_serviceUrl) {
    console.log(_serviceUrl);
    var layerName = value.replace(/^.*\/|\.[^.]*$/g, "");

    let source = {
      url: _serviceUrl,
      type: "WMS",
    };

    fetch(
      window["appConfig"]()["api"](),
      "POST",
      {},
      [fetchLayersRequest(source)],
      (resp) => {
        if (resp.data) {
          if (resp.data[0]) {
            if (resp.data[0]._response) {
              if (resp.data[0]._response._serviceId) {
                const sourcetmp = fetchSourceResponseFormatter(resp.data);

                store.dispatch({ type: "source/add", payload: sourcetmp });

                source.id = resp.data[0]._response._serviceId;

                let layer = null;

                resp.data[0]._response._layers.forEach((el) => {
                  if (el._layerName === layerName) {
                    layer = layerResponseFormatter(el);
                    layer.source = source;
                    layer.singleTile = true;
                    layer.searchable = false;
                    layer.queryable = false;

                    addLayer(layer, null, true);
                  }
                });
              }
            }
          }
        }
      }
    );
  }
}

function Hrakleio_addDiagToMapRenderer(value, edit, attributes) {
  if (edit) {
    return <input type="text" {...attributes} value={value}></input>;
  } else {
    let output = [];

    if (value != "" && value != "Δεν Βρέθηκαν δεδομένα") {
      if (value != null && value != "(Null)") {
        var valueArr = value.split("|");

        value = "";

        for (var i = 0; i < valueArr.length; i++) {
          let photo = valueArr[i];
          output.push(
            <div>
              <div>{valueArr[i]}</div>
              <span
                className="d-block small mt-2"
                role="button"
                onClick={() => {
                  console.log(photo);
                  addDiagToMap(photo);
                }}
              >
                <i className="fas fa-plus me-2"></i>
                {trans("Add to map")}
              </span>
            </div>
          );
        }
      }
    }

    return output.length > 0 ? output : value;
  }
}

export default Hrakleio_addDiagToMapRenderer;
